import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField
} from '@mui/material';

const ActionConfirmationDialog = ({
  dialogOpen,
  handleClose,
  handleConfirm,
  actionType,
  comments,
  setComments
}) => {
  return (
    <Dialog open={dialogOpen} onClose={handleClose} maxWidth='sm' fullWidth>
      <DialogTitle sx={{ color: '#ea580c', borderBottom: '1px solid #ddd' }}>
        Confirm {actionType}
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <p>
          Do you really want to{' '}
          <strong>
            <i>{actionType.toLowerCase()}</i>
          </strong>
          ?
        </p>
        <TextField
          autoFocus
          margin='dense'
          label='Comments'
          fullWidth
          multiline
          rows={4}
          value={comments}
          onChange={e => setComments(e.target.value)}
          variant='outlined'
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button onClick={handleClose} variant='outlined'>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant='contained'
          sx={{
            backgroundColor: '#ea580c',
            '&:hover': {
              backgroundColor: '#ea580c',
              opacity: 0.9
            }
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActionConfirmationDialog;
